/* eslint-disable brace-style, object-curly-spacing */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");

var draw = require("./molecule/molecule-drawing.jsx");

var _require = require("./molecule/molecule-layout.jsx"),
    layout = _require.layout;

var SmilesParser = require("./molecule/smiles-parser.jsx");

var parse = SmilesParser.parse;
var ParseError = SmilesParser.ParseError;

var borderSize = 30;

var Molecule = React.createClass({
    displayName: "Molecule",

    propTypes: {
        id: React.PropTypes.string.isRequired,
        rotationAngle: React.PropTypes.number,
        smiles: React.PropTypes.string
    },

    getInitialState: function getInitialState() {
        return { parsedSmiles: null, error: null };
    },

    componentWillMount: function componentWillMount() {
        this.stateFromSmiles(this.props.smiles);
    },

    componentDidMount: function componentDidMount() {
        this.canvasRender();
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        this.stateFromSmiles(nextProps.smiles);
    },

    componentDidUpdate: function componentDidUpdate() {
        this.canvasRender();
    },

    stateFromSmiles: function stateFromSmiles(smiles) {
        try {
            this.setState({
                parsedSmiles: parse(smiles),
                error: null
            });
        } catch (e) {
            if (e instanceof ParseError) {
                this.setState({ error: e.message });
            } else {
                throw e;
            }
        }
    },

    setCanvasBounds: function setCanvasBounds(canvas, items) {
        var xmax = Math.max.apply(Math, items.map(function (item) {
            return item.pos ? item.pos[0] : -Infinity;
        }));
        var ymax = Math.max.apply(Math, items.map(function (item) {
            return item.pos ? item.pos[1] : -Infinity;
        }));
        var xmin = Math.min.apply(Math, items.map(function (item) {
            return item.pos ? item.pos[0] : Infinity;
        }));
        var ymin = Math.min.apply(Math, items.map(function (item) {
            return item.pos ? item.pos[1] : Infinity;
        }));
        var width = xmax - xmin + 2 * borderSize;
        var height = ymax - ymin + 2 * borderSize;
        canvas.width = width;
        canvas.height = height;
        return [borderSize - xmin, borderSize - ymin];
    },

    canvasRender: function canvasRender() {
        // Since canvas drawing happens only through an imperative API, we sync
        // up the component with the canvas here, which happens when the
        // component mounts or updates.
        if (!!this.state.error || !this.state.parsedSmiles) {
            return;
        }
        var items = layout(this.state.parsedSmiles, this.props.rotationAngle);
        var canvas = this.refs.canvas;
        var translation = this.setCanvasBounds(canvas, items);
        var ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.save();
        ctx.translate(translation[0], translation[1]);
        draw(ctx, items);
        ctx.restore();
    },
    render: function render() {
        // TODO(colin): escape the punctuation in the SMILES alt text for
        // screen readers?
        var content = React.createElement(
            "canvas",
            {
                className: "molecule-canvas",
                id: this.props.id + "-molecule",
                ref: "canvas"
            },
            "A molecular structure drawing. SMILES notation:",
            this.props.smiles,
            "."
        );
        if (this.state.error) {
            content = React.createElement(
                "div",
                { className: "error" },
                this.state.error
            );
        }
        return React.createElement(
            "div",
            { className: "molecule-canvas" },
            content
        );
    }
});

var MoleculeWidget = React.createClass({
    displayName: "MoleculeWidget",

    propTypes: {
        rotationAngle: React.PropTypes.number,
        smiles: React.PropTypes.string,
        widgetId: React.PropTypes.string
    },

    getDefaultProps: function getDefaultProps() {
        return { rotationAngle: 0 };
    },

    simpleValidate: function simpleValidate() {
        return { type: "points", earned: 0, total: 0, message: null };
    },

    getUserInput: function getUserInput() {
        return [];
    },

    validate: function validate(state, rubric) {
        // TODO(colin): this is here as part of the interface for a component.
        // Figure out if there is something more appropriate that this should
        // return.
        return {
            type: "points",
            earned: 0,
            total: 0,
            message: null
        };
    },

    render: function render() {
        return React.createElement(Molecule, {
            id: this.props.widgetId,
            smiles: this.props.smiles,
            rotationAngle: this.props.rotationAngle
        });
    }
});

module.exports = {
    name: "molecule-renderer",
    displayName: "Molecule renderer",
    hidden: true,
    widget: MoleculeWidget,
    molecule: Molecule
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/molecule.jsx
 ** module id = 128
 ** module chunks = 0 1
 **/